import { useEffect, useState } from 'react'
import { ClientService } from '../../component/services/client.service'
import { Button, Card, OverlayTrigger, Spinner, Table, Tooltip } from 'react-bootstrap';
import TablePaginationComponent from '../../component/table/TablePagination';
import { FaInfoCircle } from 'react-icons/fa';
import SplitPreviewModal from '../../component/modals/SplitPreview.modal';
import { FaCircleCheck, FaCircleXmark } from 'react-icons/fa6';
import toast from 'react-hot-toast';
import { HiRefresh } from "react-icons/hi";

export default function ReverifyCandidates() {

    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [splitPreviewData, setSplitPreviewData] = useState<any>(null);
    const [totalCount, setTotalCount] = useState<number>(0);

    async function getFacialExceptions() {
        setLoading(true);
        await ClientService.getFacialExceptions(pageNumber, pageSize)
            .then((res) => {
                setTableData(res.data?.verification || []);
                setTotalCount(res.data?.total);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    async function handleAccept(verificationId: string) {
        await ClientService.acceptFacialException(verificationId)
            .then((res) => {
                getFacialExceptions();
                toast.success("Facial verification accepted");
            })
            .catch((err) => {
                console.log(err);
                toast.error(err.response?.data || 'Failed to reject facial verification');
            });
    }

    async function handleReject(verificationId: string) {
        await ClientService.rejectFacialException(verificationId)
            .then((res) => {
                console.log(res);
                toast.success("Facial verification rejected");
                getFacialExceptions();
            })
            .catch((err) => {
                console.log(err);
                toast.error(err.response?.data || 'Failed to reject facial verification');
            });
    }

    useEffect(() => {
        getFacialExceptions();
    }, [pageNumber, pageSize]);

    return (
        <>
            <Card className="mt-4 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
                <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="text-secondary fw-bold" style={{ fontSize: '18px' }}>
                            Reverify Candidates
                        </h5>
                        <HiRefresh style={{ cursor: "pointer" }} onClick={getFacialExceptions} size = {20} />
                    </div>

                    <div className="table-responsive">
                        <Table hover className="align-middle mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th className="py-3" style={{ fontSize: '14px', fontWeight: 600 }}>#</th>
                                    <th className="py-3" style={{ fontSize: '14px', fontWeight: 600 }}>Student Details</th>
                                    <th className="py-3" style={{ fontSize: '14px', fontWeight: 600 }}>Verification Info</th>
                                    <th className="py-3" style={{ fontSize: '14px', fontWeight: 600 }}>Location</th>
                                    <th className="py-3" style={{ fontSize: '14px', fontWeight: 600 }}>Status</th>
                                    <th className="py-3" style={{ fontSize: '14px', fontWeight: 600 }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={6} className="text-center py-4">
                                            <Spinner animation="border" size="sm" className="text-primary" />
                                        </td>
                                    </tr>
                                ) : tableData?.length > 0 ? (
                                    tableData.map((item: any, index: number) => {
                                        const facialVerification = item?.verificationDetails?.find(
                                            (detail: any) => detail?.method === 'facial'
                                        );

                                        let facial = "Not Available";
                                        let facial_bypass = undefined;
                                        if (!facial) {
                                            facial = "Not Available";
                                        }
                                        else {
                                            if (facialVerification?.success) {
                                                facial = "Verified";
                                            }
                                            if (facialVerification.manuallyVerified) {
                                                facial = "Bypassed";
                                                facial_bypass = facialVerification?.bypassReason || "-";
                                            }
                                        }

                                        return (
                                            <tr key={item?._id}>
                                                <td className="align-middle">
                                                    <span className="text-secondary fw-medium">
                                                        {index + 1 + (pageNumber - 1) * pageSize}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="position-relative"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => setSplitPreviewData({ uploadPhoto: item?.studentId?.avatar, livePhoto: item?.userLivePhoto })}
                                                        >
                                                            <img
                                                                src={item?.studentId?.avatar}
                                                                alt="Student"
                                                                className="rounded-circle"
                                                                style={{ width: 48, height: 48, objectFit: 'cover' }}
                                                            />
                                                        </div>
                                                        <div className="ms-3">
                                                            <h6 className="fw-medium mb-1" style={{ fontSize: '14px' }}>
                                                                {item?.studentId?.name}
                                                            </h6>
                                                            <p className="text-primary mb-1" style={{ fontSize: '13px' }}>
                                                                {item?.studentId?.rollNo}
                                                            </p>
                                                            <small className="text-muted">
                                                                {item?.studentId?.centerPreference}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div
                                                            className="position-relative"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => setSplitPreviewData({ uploadPhoto: item?.studentId?.avatar, livePhoto: item?.userLivePhoto })}
                                                        >
                                                            <img
                                                                src={item?.userLivePhoto}
                                                                alt="Verification"
                                                                className="rounded-circle"
                                                                style={{ width: 48, height: 48, objectFit: 'cover' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style={{ fontSize: '13px' }}>
                                                        {item?.studentId?.state && (
                                                            <div className="d-flex align-items-center mb-1">
                                                                <span className="text-muted" style={{ width: '45px' }}>State:</span>
                                                                <span className="text-secondary ms-2">{item?.studentId?.state}</span>
                                                            </div>
                                                        )}
                                                        {item?.studentId?.zone && (
                                                            <div className="d-flex align-items-center mb-1">
                                                                <span className="text-muted" style={{ width: '45px' }}>Zone:</span>
                                                                <span className="text-secondary ms-2">{item?.studentId?.zone}</span>
                                                            </div>
                                                        )}
                                                        {item?.studentId?.city && (
                                                            <div className="d-flex align-items-center">
                                                                <span className="text-muted" style={{ width: '45px' }}>City:</span>
                                                                <span className="text-secondary ms-2">{item?.studentId?.city}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        {facial === "Not Available" && (
                                                            <span className="badge bg-secondary-subtle text-secondary px-3 py-2">
                                                                Not Available
                                                            </span>
                                                        )}
                                                        {facial === "Verified" && (
                                                            <span className="badge bg-success-subtle text-success px-3 py-2">
                                                                Verified
                                                            </span>
                                                        )}
                                                        {facial === "Bypassed" && (
                                                            <div className="d-flex align-items-center">
                                                                <span className="badge bg-warning-subtle text-warning px-3 py-2">
                                                                    Bypassed
                                                                </span>
                                                                <OverlayTrigger
                                                                    placement="left"
                                                                    delay={{ show: 250, hide: 400 }}
                                                                    overlay={
                                                                        <Tooltip id={`tooltip-${index}`}>
                                                                            {facial_bypass}
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className='text-warning ms-2' style={{ cursor: 'pointer' }}>
                                                                        <FaInfoCircle size={16} />
                                                                    </span>
                                                                </OverlayTrigger>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <div className="d-flex align-items-center">
                                                            <Button size='sm' variant="success" className='ms-2' onClick={() => handleAccept(item?._id)}>
                                                                <FaCircleCheck size={16} /> Accept
                                                            </Button>
                                                            <Button size='sm' variant="outline-danger" className='ms-2' onClick={() => handleReject(item?._id)}>
                                                                <FaCircleXmark size={16} /> Reject
                                                            </Button>
                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={14} className="text-center">
                                            No Data Available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="mt-4 pt-2">
                        <TablePaginationComponent
                            currentPage={pageNumber}
                            itemsCount={totalCount}
                            itemsPerPage={pageSize}
                            setItemsPerPage={(e: any) => setPageSize(e)}
                            setCurrentPage={setPageNumber}
                        />
                    </div>
                </Card.Body>
            </Card>

            <SplitPreviewModal
                show={splitPreviewData}
                handleClose={() => setSplitPreviewData(null)}
            />
        </>
    )
}